import { HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { Common } from 'src/app/demo/utils/common';
import { WebStorage } from '../../../auth/storage/web.storage';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-staff-mark-absent',
  templateUrl: './staff-mark-absent.component.html',
  styleUrls: ['./staff-mark-absent.component.scss']
})
export class StaffMarkAbsentComponent {
  userData: any;
  search: any = {};
  pageContext = {
    page: 0,
    previousPage: 0,
    itemsPerPage: 25,
    totalItems: 0,
    sort: 'id,asc',
  };
  roomList: RoomDTO[] = [];
  roomObj: RoomDTO = {};
  designationList: MasterLookupDTO[] = [];
  selectedRoomId: any;
  selectedDesignation: any;
  selectedStatus: any;
  staffList: StaffDTO[] = [];
  selectAllStaff: boolean = false;
  selectedStaff: any[] = [];
  selectedStudentIds: number[] = [];
  selectedStaffList: any[] = [];
  actualStaffList: StaffDTO[] = [];
  staffSearchInput: any;
  submitForm: boolean = false;
  items!: MenuItem[];
  activeIndex: number = 0;
  profileBgColor: string[] = [];
  selectedDate: any = Common.momentTimeZoneDate(new Date());
  staffSignIn!: FormGroup;
  fromDate !: string;
  todayDate!: string;
  toDate !: string;
  dateClickedFirstTime: boolean = false;
  fromOverView: boolean = false;
  presentStaffIds: any[] = [];
  constructor(
    private lookupService: LookupService,
    private operationService: OperationService,
    private storage: WebStorage,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {
    this.roomObj = this.config.data;
    this.profileBgColor = profielBackgroundColor;
    this.activeIndex = this.config.data.activeIndex;
    this.fromOverView = this.config.data.fromOverView ? true : false;
    this.selectedStaff = this.fromOverView ? this.config.data.selectedStaffs : [];
    this.selectedStaffList = this.fromOverView ? this.config.data.selectedStaffs : [];
    this.presentStaffIds = this.config.data.presentStaffIds;
  }

  ngOnInit(): void {
    this.userData = this.storage.getUserData();
    const currentTime24hr = Common.momentTimeZoneTime(new Date());
    const currentDate = Common.momentTimeZoneDate(new Date());

    this.items = [
      {
        label: 'Select Staff',
        command: (event: any) =>
          this.messageService.add({
            severity: 'info',
            summary: 'First Step',
            key: 'message',
            detail: event.item.label,
            life: 3000,
          }),
      },
      {
        label: 'Confirm Staff',
        command: (event: any) =>
          this.messageService.add({
            severity: 'info',
            key: 'message',
            summary: 'Second Step',
            detail: event.item.label,
            life: 3000,
          }),
      },
    ];
    this.staffSignIn = this.formBuilder.group({
      id: [''],
      signInTime: [currentTime24hr],
      signOutTime: [''],
      attendedTime: [''],
      signInBy: [''],
      signOutBy: [''],
      note: [''],
      hasSignIn: [true],
      date: [currentDate],
      roomId: [''],
      staffName: [''],
      status: 'A',
      schoolId: [''],
      hasStudentId: [''],
    });
    this.fromDate = Common.momentTimeZoneDate(new Date);
    this.toDate = Common.momentTimeZoneDate(new Date);
    this.todayDate = Common.momentTimeZoneDate(new Date);
    this.queryData();
    this.getRoomData();
    this.getDesignationData();
  }

  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  complete() {
    if (this.selectedStudentIds.length != 0) {
      this.activeIndex = 1;
    } else {
      this.activeIndex = 0;
    }
  }

  prevPage() {
    this.activeIndex = 0;
  }

  callOnce : boolean = false;
  onSave() {
    if (!this.callOnce && Array.isArray(this.selectedStaffList) && this.selectedStaffList.length > 0) {
      this.callOnce = true;
      const requests: any[] = []; // Store API call observables
      // const formatTo12Hour = (time: string): string => {
      //   if (!time) return ''; // Handle undefined or null cases
      //   const [hours, minutes] = time.split(':'); // Extract hours and minutes
      //   let hour = parseInt(hours, 10);
      //   const ampm = hour >= 12 ? 'PM' : 'AM';
      //   hour = hour % 12 || 12;
      //   return `${hour.toString().padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
      // };
      // Loop through selected staff and create individual payloads
      for (const staff of this.selectedStaffList) {
        const payload: any = {
          note: staff.absentNote || "",
          // startDate: Common.convertLocalDateToUTC(this.fromDate),
          // endDate: Common.convertLocalDateToUTC(this.toDate),
          fromDate: this.fromDate,
          toDate: this.toDate ?? this.fromDate,
          status: "A",
          schoolId: this.userData.schoolId,
          staffId: staff.id,
          lastModified: moment.utc().format(),
          lastModifiedBy: this.userData.email + " from Mobile",
          roomId: staff.primaryRoomId,
          absentMarkTime: Common.convertLocalDateToUTC(Common.momentTimeZoneDate(new Date())),
          // absentBy: this.userData.firstName,
          absentMarkedBy: this.userData.firstName,
          hasStudentId: false,
          isPrimary: true
        };

        // Push API request into the array
        requests.push(this.operationService.createAbsentMultipleDays(payload));
      }

      // Use forkJoin to execute all requests
      forkJoin(requests).subscribe({
        next: () => {
          this.ref.close({
            severity: 'success',
            life: 3000,
            summary: 'Success',
            detail: 'Absent marked successfully.'
          });
          setTimeout(() => {
            this.router.navigateByUrl('/staff/viewAttendance/absent-view');
            this.callOnce = false;
          }, 1000);
        },
        error: (error) => {
          this.ref.close({
            severity: 'error',
            life: 3000,
            summary: 'Error',
            detail: error?.error?.detail || 'An error occurred while submitting.'
          });
          this.callOnce = false; // Reset callOnce on error
        }
      });
    }
  }

  queryData() {
    this.search['profileStatus.equals'] = 'A';
    this.search['status.equals'] = 'A';
    // this.search['staffId.notIn'] = (moment(this.toDate).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')
    //   || moment(this.fromDate).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) ? this.presentStaffIds : undefined;
    if (this.fromDate && this.toDate) {

      this.search["date.greaterThanOrEqual"] = Common.getUtcStartOfDay(this.fromDate);
      this.search["date.lessThanOrEqual"] = Common.getUtcEndOfDay(this.toDate);
    }
    this.search['name.contains'] = this.staffSearchInput;
    this.search['size'] = 50;
    this.search['sort'] = 'name,asc';
    this.search['roomId.equals'] = this.selectedRoomId;
    this.search['designation.in'] = this.selectedDesignation;
    this.search['schoolId.equals'] = this.userData.schoolId;
    this.search['designation.notEquals'] = 'Kiosk';
    Common.removeEmptyFields(this.search);
    this.lookupService
      .queryStaffAbsent(this.search)
      .subscribe(async (res: HttpResponse<StaffDTO[]>) => {
        let temp: StaffDTO[] = [];
        this.staffList = res.body ? res.body : temp;
        this.actualStaffList = this.staffList;
        for (const staff of this.staffList) {
          if (staff) {
            if (staff.photoUuid) {
              this.lookupService
                .queryDocumentByPhotoUid(staff.photoUuid)
                .subscribe((response: HttpResponse<Blob>) => {
                  const body = response?.body;
                  if (body) {
                    const url =
                      this.createImgFromBuffer(body);
                    staff.profileimg = url;
                  }
                });
            } else {
              staff.profileimg = undefined;
            }
          }
        }
      });
  }

  getRoomData() {
    this.search = {};
    this.search['sort'] = 'name,asc';
    this.search['status.equals'] = 'A';
    this.search['id.notEquals'] = this.roomObj.id;
    this.search.size = 500;
    this.search['schoolId.equals'] = this.userData.schoolId;
    Common.removeEmptyFields(this.search);
    this.lookupService
      .queryRooms(this.search)
      .subscribe((res: HttpResponse<RoomDTO[]>) => {
        let temp: RoomDTO[] = [];
        this.roomList = res.body ? res.body : temp;
      });
  }

  getDesignationData() {
    this.lookupService
      .queryMasterLookups({
        'schoolId.equals': this.userData.schoolId,
        'type.equals': 'Designation',
        'name.notEquals': 'Kiosk',
        'status.equals': 'A',
      })
      .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
        let temp: MasterLookupDTO[] = [];
        this.designationList = res.body ? res.body : temp;
      });
  }

  createImgFromBuffer(blob: Blob) {
    const url = URL.createObjectURL(blob);
    return url;
  }

  onClear() {
    this.staffSearchInput = [];
    this.selectedRoomId = undefined;
    this.selectedDesignation = [];
    this.selectedStaff = [];
    this.actualStaffList = [];
    this.selectedStudentIds = [];
    this.selectAllStaff = false;
    this.fromDate = Common.momentTimeZoneDate(new Date);
    this.toDate = Common.momentTimeZoneDate(new Date);
    this.todayDate = Common.momentTimeZoneDate(new Date);
    this.filter();
    this.filterRoom();
    this.filterDesig();
    this.queryData();
  }

  filter() {
    let filtered: StaffDTO[] = [];

    if (this.staffSearchInput.length !== 0) {
      for (let i = 0; i < this.staffList.length; i++) {
        let user = this.staffList[i];
        if (
          user?.name &&
          (user.name
            .toLowerCase()
            .indexOf(this.staffSearchInput.toLowerCase()) === 0 ||
            user.name
              .toLowerCase()
              .includes(this.staffSearchInput.toLowerCase()))
        ) {
          filtered.push(user);
        }
      }
    } else {
      filtered = [...this.actualStaffList];
    }

    this.staffList = [...filtered];
    this.checkboxChanged();
  }

  filterRoom() {
    let filtered: StaffDTO[] = [];
    this.staffList = [...this.actualStaffList];
    if (this.selectedRoomId != undefined) {
      for (let i = 0; i < this.staffList.length; i++) {
        let user = this.staffList[i];
        if (user?.primaryRoomId && (user.primaryRoomId == this.selectedRoomId)) {
          filtered.push(user);
        }
      }
    } else {
      filtered = [...this.actualStaffList];
    }


    this.staffList = [...filtered];

    this.checkboxChanged();
  }
  filterDesig() {
    let filtered: StaffDTO[] = [];
    if (this.selectedDesignation.length == 0) {
      filtered = [...this.actualStaffList];
    } else {
      // Create a Set for more efficient lookup
      const selectedTagSet = new Set(this.selectedDesignation);

      filtered = this.actualStaffList.filter(
        (user) =>
          user?.designation && selectedTagSet.has(user.designation)
      );
    }
    this.staffList = [...filtered];
    this.checkboxChanged();
  }

  onRemoveStaff(event: Event, staff: any) {
    this.confirmationService.confirm({
      key: 'confirm2',
      target: event.target as EventTarget,
      message: `Do you want to Remove ${staff.name}?`,
      acceptButtonStyleClass: 'p-button-primary p-button-raised',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
      defaultFocus: 'none',
      accept: () => this.deleteStaff(staff),
      reject: () => { },
    });
  }

  deleteStaff(stud: any) {
    const indexToRemove = this.selectedStaffList.findIndex(
      (staff) => staff.id === stud.id
    );

    if (indexToRemove != -1) {
      this.selectedStaffList.splice(indexToRemove, 1);

      const seletedIds = this.selectedStudentIds.findIndex(
        (staff) => staff == stud.id
      );
      this.selectedStudentIds.splice(seletedIds, 1);

      const selectedStaff = this.selectedStaff.findIndex(
        (staff) => staff.id == stud.id
      );
      this.selectedStaff.splice(selectedStaff, 1);

      this.selectAllStaff = false;

      const mainListIndex = this.staffList.findIndex(
        (staff) => staff.id == stud.id
      );
      if (mainListIndex != -1) {
        this.staffList[mainListIndex].selected = false;
      }
      this.submitForm = false;
      // Show success message
      this.messageService.add({
        key: 'message',
        severity: 'success',
        life: 3000,
        summary: 'Success',
        detail: `Staff Removed Successfully.`,
      });
    }
  }

  toggleSelection(staff: any) {
    const index = this.selectedStaff.findIndex(
      (selected) => selected.id === staff.id
    );
    if (index !== -1) {
      this.selectedStaff.splice(index, 1);
    } else {
      this.selectedStaff.push(staff);
    }
    this.selectedStudentIds = this.selectedStaff.map(
      (selected) => selected.id
    );

    this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
      this.selectedStudentIds.includes(item.id as number)
    );
  }

  isSelected(staff: StaffDTO): boolean {
    return this.selectedStaff.includes(staff);
  }

  toggleAllSelection() {
    this.staffList.forEach(
      (staff) => (staff.selected = this.selectAllStaff)
    );

    if (this.selectAllStaff) {
      this.selectedStaff = [...this.staffList];
    } else {
      this.selectedStaff = [];
    }
    this.selectedStudentIds = this.selectedStaff.map(
      (selected) => selected.id
    );

    this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
      this.selectedStudentIds.includes(item.id as number)
    );
  }

  checkboxChanged() {
    if (this.staffList && this.staffList?.length !== 0) {
      if (this.isAllSelected()) this.selectAllStaff = true;
      else this.selectAllStaff = false;
    } else {
      this.selectAllStaff = false;
    }
  }

  isAllSelected(): boolean {
    return this.staffList.every((staff) => staff.selected);
  }

  private patchDateValue(dateValue: any): string {
    let formattedDate;
    // Check if the value is a valid date before formatting
    if (dateValue && !isNaN(new Date(dateValue).getTime())) {
      formattedDate = Common.convertLocalDateToUTC(dateValue)
    } else {
      // If the value is not a valid date, set it to null or handle it accordingly
      formattedDate = '';
    }
    return formattedDate;
  }

  getBackgroundColor(roomId: number): string {
    if (!roomId) return this.profileBgColor[0];
    const index = (roomId - 1) % this.profileBgColor.length;
    return this.profileBgColor[index];
  }

  getInitials(name: string): string {
    const words = name.trim().split(/[-\s]+/); // Split by hyphens or spaces
    const firstLetter = words[0][0]?.toUpperCase(); // Get the first letter of the first word
    const secondLetter = words[1]?.[0]?.toUpperCase() || ''; // Get the first letter of the second word (if it exists)
    return `${firstLetter}${secondLetter}`.trim(); // Concatenate and trim
  }

  onClickDate(clickedDate: string) {
    if (clickedDate === 'fromDate') {
      // Ensure fromDate is not in the past
      const today = Common.momentTimeZoneDate(new Date());
      if (this.fromDate < today) {
        this.fromDate = today;
      }
      this.toDate = this.fromDate;
    }
    this.dateClickedFirstTime = true;
    this.search = {};
    this.queryData();
  }
}
